import {AdvancedMarker} from '@vis.gl/react-google-maps';
import React from 'react';
import {useTrip} from '../../context/TripContext';
import {Poi} from '../../../react-app-env';
import {Events, EventType} from '../../../events/Events';
import {ReactComponent as MarkerSvg} from '../../../images/map/marker.svg';
import Icon, {IconSizes} from '../../icon/Icon';
import {getPoiCategoryIconCategory} from '../../../utils/PoiCategoryUtils';
import {useHoveringPois} from '../../context/HoveringPoisContext';
import {useSelectedPoi} from '../../context/SelectedPoiContext';

function MapItineraryPoiLayer() {
  const trip = useTrip();
  const hoveringPois = useHoveringPois();
  const selectedPoi = useSelectedPoi();

  function buildPoiMarker(poi: Poi): any {
    const iconCategory = getPoiCategoryIconCategory(poi.category);
    const isHovering = hoveringPois.some(hoveringPoi => hoveringPoi.id === poi.id);
    const isSelected = selectedPoi?.id === poi.id;

    const cssClassNames = ['fr-marker'];
    if (isHovering) {
      cssClassNames.push('fr-marker--hover');
    }
    if (isSelected) {
      cssClassNames.push('fr-marker--selected');
    }

    let zIndex = undefined;
    if (isHovering) {
      zIndex = 10001;
    }
    if (isSelected) {
      zIndex = 10000;
    }

    return <AdvancedMarker
        key={poi.id}
        position={poi.location}
        className={cssClassNames.join(' ')}
        title={poi.title}
        zIndex={zIndex}
        onClick={() => Events.publish(EventType.SELECT_POI, poi)}
        onMouseEnter={() => Events.publish(EventType.ON_POIS_HOVERING, [poi])}
        onMouseLeave={() => Events.publish(EventType.ON_POIS_HOVERING, [])}>
      <MarkerSvg/>
      {iconCategory && <Icon category={iconCategory} size={IconSizes.SMALL}/>}
      <div className='fr-marker--title'>{poi.title}</div>
    </AdvancedMarker>;
  }

  return <React.Fragment>
    {trip.pois.map(poi => buildPoiMarker(poi))}
  </React.Fragment>;
}

export default MapItineraryPoiLayer;
